import React, { Component, } from 'react';
import { object, func, string, arrayOf, } from 'prop-types';
import styled from 'styled-components';
import Widget from '../../legacy-tv-ui/Widget';
import Grid from '@material-ui/core/Grid';
import { connect, } from 'react-redux';
import _ from 'lodash';

import fetchDateList from './actions/fetchDateList';

const DateListItem = styled.li`
  padding: 8px 15px;
  margin: 4px;
  background: #f5f5f5;
  display: inline-block;
  box-sizing: border-box;
  cursor: pointer;
  &:hover {
    background: #eee
  }
`;
const GroupBlock = styled.div`
  text-align: left;
  border-bottom: 1px solid #ddd;
  padding: 15px;
  &:last-child {
    border-bottom: none;
  }
`;
const GroupTitle = styled.h3`
  padding-left: 10px;
  font-weight: normal;
  letter-spacing: 1px;
  margin-bottom: 0;
`;

export function mapListToGroups(dateList) {
  return dateList.reduce((pre, [year, month]) => {
    if (!pre[year]) {
      pre[year] = [month];
    } else {
      pre[year].push(month);
    }
    return pre;
  }, {});
}

export class DateSelect extends Component {
  static propTypes = {
    match: object.isRequired,
    fetchDateList: func.isRequired,
    token: string.isRequired,
    company: string.isRequired,
    dateList: arrayOf(arrayOf(string)).isRequired,
    history: object.isRequired,
  }
  static defaultProps = {}
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    const {
      fetchDateList,
      dateList,
      token,
      company,
    } = this.props;

    if (dateList.length === 0) {
      fetchDateList(company, token);
    }
  }
  goToDate = (year, month) => {
    const {
      history,
      match,
    } = this.props;
    history.push(`/${match.params.projectId}/${year}/${month}/performance`);
  }
  render() {
    const { dateList, } = this.props;
    const dateGroups = mapListToGroups(dateList);
    return (<div>
      <Grid container>
        <Grid item xs={12} sm={3} lg={3} />
        <Grid item xs={12} sm={6} lg={6}>
          <Widget
            title="請選擇月份"
            style={
              {
                marginTop: 100,
                textAlign: 'center',
              }
            }
          >
            {
              _.sortBy(
                _.keys(dateGroups),
                year => -year
              )

                .map(year => (
                  <GroupBlock>
                    <GroupTitle>{year}</GroupTitle>
                    <ul>
                      {
                        _.sortBy(dateGroups[year], month => +month)
                          .map(month => (
                            <DateListItem
                              key={month}
                              onClick={() => this.goToDate(year, month)}
                            >
                              {month}月
                            </DateListItem>
                          ))
                      }
                    </ul>
                  </GroupBlock>
                ))
            }
          </Widget>
        </Grid>
      </Grid>

    </div>);
  }
}

function mapStateToProps(state) {
  return {
    dateList: state.appState.dateList,
    token: state.appState.userToken,
    company: state.appState.company,
  };
}

const dispatchObj = {
  fetchDateList,
};

export default connect(mapStateToProps, dispatchObj)(DateSelect);



// WEBPACK FOOTER //
// ./src/scenes/DateSelect/index.js